<template>
  <span>
    <v-progress-circular
      v-if="size === regular"
      :value="getFill(total)"
      :size="80"
      :width="10"
      :color="getGolor(total)"
      class="mr-2 mb-2"
    >
      <span style="white-space: nowrap;color:black">{{ total }} st</span>
    </v-progress-circular>
   
    <span v-if="(bundle.open || bundle.open === undefined) && size === small">
      <v-progress-circular        
        :value="getFill(total)"
        :size="20"
        :width="10"
        :color="getGolor(total)"
        class="mr-2 mb-1"
      />
      <span style="white-space: nowrap;color:black">#{{ bundle.id }}</span>&nbsp;
    </span>

    <v-card v-if="size === large" flat>      
      <v-card-text class="pb-0 pt-2">
        <v-row align="center">
          <v-col>
            <h3>
              # {{ bundle.id }}
            </h3>
          </v-col>
          <v-col>
            <v-progress-circular          
              :value="getFill(total)"
              :size="70"
              :width="10"
              :color="getGolor(total)"
              class="mr-2 mb-2"
            >
              <span style="white-space: nowrap;color:black">{{ total }} st</span>
            </v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>     
    </v-card>  
  </span>  
</template>

<script>
import { isFinite } from 'lodash'

const SMALL = 'small'
const REGULAR = 'regular'
const LARGE = 'large'

export default {
  name: 'BundleProgress',
  props: {
    bundle: { 
      type: Object, 
      required: true
    },
    extra: { 
      type: Number, 
      required: true
    },
    size: { 
      type: String, 
      required: true, 
      validator: function (value) {
        return [REGULAR, SMALL, LARGE].indexOf(value) !== -1
      }
    },
  },
  data() {
    return {
      total: 0,
      small: SMALL,
      regular: REGULAR,
       large: LARGE
    }
  },
  watch: {
    'extra': function (val) {
      this.calculateTotal(this.bundle, val)
    },
    'bundle': function (val) {
      this.calculateTotal(val, this.extra)
    }
  },
  created() {
    this.calculateTotal(this.bundle, this.extra)
  },
  methods: {
    getFill(value) {
      this.$emit('input', value >= 50)
      return value * 2
    },
    isFull() {
      return true
    },
    getGolor(value) {
      if (value >= 50) return 'red'
      if (value >= 40) return 'orange'
      return 'green'
    },
    calculateTotal(bundle, extra) {
      var total = 0
      bundle.returnReports.forEach(p => {
        total = total + p.returnAmount
      })
      if (isFinite(extra)) {
        total = total + extra
      }
      this.total = total
    }
  }
}
</script>
